import React, {useState} from 'react';
import { Text, TouchableOpacity, View, StyleSheet } from 'react-native';
import {LinearGradient} from 'expo-linear-gradient';
import I18n from 'i18n-js';
import { useDispatch, useSelector } from 'react-redux';
import { handleCartData, ResetCartInProgress, ReSetCartProgress } from '../../actions/scanToCartActions';
import { navigate } from '../root_navigation';
import { sharedPromptStyles, basePromptContainer, baseResponseView, baseTitleText, baseButtonText, baseActionButton } from './shared/promptStyles';

const ResumePickingPrompt = () => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const pickingSessionData = useSelector(state => state.scanToCart.pickingSessionData);
  const errorMessage = useSelector(state => state.scanToCart.hasActivePickingErrorMessage);

  const dispatch = useDispatch();

  const handleContinuePick = () => {
    dispatch(handleCartData(pickingSessionData));
    navigate('ScanToCart');
  };

  const handleClearCart = () => {
    setShowConfirmation(true);
  };

  const handleConfirmClear = () => {
    dispatch(ReSetCartProgress(pickingSessionData.cart_id,handleClosePrompt))
  };

  const handleCancelConfirmation = () => {
    setShowConfirmation(false);
  };

  const handleClosePrompt = () => {
    dispatch(ResetCartInProgress());
  };

  const GradientButton = ({text, onPress, testID}) => (
    <TouchableOpacity testID={testID} onPress={onPress} style={styles.fullWidthButton}>
      <LinearGradient
        locations={[0, 0.7, 1]}
        start={{x: 0, y: 0}}
        end={{x: 0, y: 1}}
        colors={['#ffb636', '#ffb636', '#d47d02']}
        style={styles.actionButton}>
        <Text style={styles.buttonText}>{text}</Text>
      </LinearGradient>
    </TouchableOpacity>
  );

  const PromptContainer = ({title, buttons}) => (
    <LinearGradient
      locations={[0, 1]}
      start={{x: 0, y: 1}}
      end={{x: 0, y: 0}}
      colors={['#d47d02', '#ffb636']}
      style={styles.promptContainer}>

      <View style={styles.cancelIcon}>
        <TouchableOpacity testID="CancelIcon" onPress={handleClosePrompt}>
          <i className="icon-cancel" style={{fontSize: 26, color: '#1C1C1C'}}></i>
        </TouchableOpacity>
      </View>

      {errorMessage && errorMessage.length > 0 && <View style={[styles.titleContainer,{marginBottom: 5}]}>
        <Text style={styles.titleText}>{errorMessage}</Text>
      </View>}
      <View style={styles.titleContainer}>
        <Text style={styles.titleText}>{title}</Text>
      </View>

      <View style={styles.buttonContainer}>
        {buttons.map((button, index) => (
          <GradientButton
            key={index}
            testID={button.testID}
            text={button.text}
            onPress={button.onPress}
          />
        ))}
      </View>
    </LinearGradient>
  );

  const mainPromptButtons = [
    {
      testID: "continuePickButton",
      text: I18n.t('resumePicking.continueButton'),
      onPress: handleContinuePick
    },
    {
      testID: "clearCartButton", 
      text: I18n.t('resumePicking.clearButton'),
      onPress: handleClearCart
    }
  ];

  const confirmationButtons = [
    {
      testID: "cancelConfirmationButton",
      text: I18n.t('resumePicking.cancelButton'),
      onPress: handleCancelConfirmation
    },
    {
      testID: "confirmClearButton",
      text: I18n.t('resumePicking.confirmButton'),
      onPress: handleConfirmClear
    }
  ];

  const mainTitle = I18n.t('resumePicking.title', {cartNumber: pickingSessionData?.cart_id || ''})

  const confirmationTitle = I18n.t('resumePicking.confirmationTitle');

  return (
    <View testID="resumePickingPrompt" style={styles.responseView}>
      <PromptContainer
        title={showConfirmation ? confirmationTitle : mainTitle}
        buttons={showConfirmation ? confirmationButtons : mainPromptButtons}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  responseView: {
    ...baseResponseView,
    justifyContent: 'center',
    top: 0,
    zIndex: 1000,
  },
  promptContainer: {
    ...basePromptContainer,
    maxWidth: 550,
  },
  cancelIcon: sharedPromptStyles.cancelIcon,
  titleContainer: sharedPromptStyles.titleContainer,
  titleText: baseTitleText,
  buttonContainer: sharedPromptStyles.buttonContainer,
  fullWidthButton: {
    width: '100%'
  },
  actionButton: {
    ...baseActionButton,
    paddingVertical: 12,
    width: '100%',
  },
  buttonText: {
    ...baseButtonText,
    textAlign: 'center'
  }
});

export default ResumePickingPrompt;
